import { render, staticRenderFns } from "./alertaSucesso.vue?vue&type=template&id=7e1a398a&scoped=true&"
import script from "./alertaSucesso.vue?vue&type=script&lang=js&"
export * from "./alertaSucesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1a398a",
  null
  
)

export default component.exports